import { render, staticRenderFns } from "./BotaoPrimario.vue?vue&type=template&id=647db8f3"
import script from "./BotaoPrimario.vue?vue&type=script&lang=js"
export * from "./BotaoPrimario.vue?vue&type=script&lang=js"
import style0 from "./BotaoPrimario.vue?vue&type=style&index=0&id=647db8f3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports